<template>
  <div class="main">
    <mt-header :title="$t('行情显示色选项')" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>

    <div class="container">
      <mt-radio
        align="right"
        v-model="checkValue"
        :options="defaultResult"
      ></mt-radio>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  name: "RedGreen",
  components: { Toast },
  data() {
    return {
      checkValue: this.$store.state.hangqing
    };
  },
  created() {
    this.defaultResult = [
      {
        label:this.$t("绿涨红跌"),
        value:"0"
      },
      {
        label:this.$t("红涨绿跌"),
        value:"1"
      }
    ];
  },
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    }
  },
  watch: {
    checkValue: function(val, old) {
      this.$store.dispatch("setHangqing", val);
    }
  }
};
</script>

<style scoped>
.main {
  padding-top: 40px;
}
.container {
  padding: 50px 10px 10px 10px;
}
</style>

